import Vue from 'vue';
import { Client } from '@stomp/stompjs';

const client = new Client({
  brokerURL: `${process.env.WEBSOCKET_URL}`,
  appendMissingNULLonIncoming: true,
  reconnectDelay: 5000,
});
// const boot = ({ store }) => {

// };

// export { boot as default };

Vue.prototype.$stomp = client;
